import React, { useRef } from "react";

import * as S from "./styles";

export const Slide13: React.FC = () => {
  const videoRef = useRef<HTMLVideoElement>(null);

  return (
    <S.Container>
      <S.Video>
        <video ref={videoRef} muted autoPlay loop playsInline>
          <source
            src="https://player.vimeo.com/external/538846579.hd.mp4?s=f43e77a33407562ad4a83c4ab3b10569dde77ba7&profile_id=175&download=1"
            type="video/mp4"
          />
        </video>
      </S.Video>
    </S.Container>
  );
};
